import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseHttpService } from '@shared/infrastructure/services/http/base-http.service';
import { environment } from '@env/environment';
import { OrderRepository } from '@features/sales/domain/repositories/order.repository';
import { Order } from '@features/sales/domain/entities/order/order.entity';

@Injectable({ providedIn: 'root' })
export class HttpOrderRepository extends BaseHttpService implements OrderRepository {
  protected readonly baseUrl = environment.apiURL;

  create(order: Order): Observable<Order> {
    // TODO: cuando el backend esté listo
    return of(order);
  }
}
